import { render, staticRenderFns } from "./ResponsiveTable.vue?vue&type=template&id=43bb6a24&scoped=true&"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js&"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveTable.vue?vue&type=style&index=0&id=43bb6a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb6a24",
  null
  
)

export default component.exports